// extracted by mini-css-extract-plugin
module.exports = {"container":"MediaInfo__container__2QLMr","description":"MediaInfo__description__kkPti text__select-text__KUePQ layout__clearfix__283mR"};